import SavedReportsTable from './SavedReportsTable';

export default SavedReportsTable;
